export default __webpack_public_path__ + "static/media/NZD.77a00790.svg";